import SuperRepository from '../superRepository'
import { paramsSerializerQs } from '@/helpers/api'

export default new (class OfferPartnersRepository extends SuperRepository {
  baseUri() {
    return 'offer_partner'
  }
  updateCostHistory = async ({ id, ...params }) =>
    this.httpClient().put(`${this.baseUri()}/${id}/update_cost_history`, params)
  updateBlDepositHistory = async ({ id, ...params }) =>
    this.httpClient().put(`${this.baseUri()}/${id}/update_bl_deposit_history`, params)
  updateBlPeriodHistory = async ({ id, ...params }) =>
    this.httpClient().put(`${this.baseUri()}/${id}/update_bl_period_history`, params)
  updateCountryRequirements = async ({ id, ...params }) =>
    this.httpClient().put(`${this.baseUri()}/${id}/update_bl_country_requirement`, params)
  exportOfferPartners = (data, params) => this.httpClient().get(`${this.baseUri()}/export-link`, data, params)
  bulkSave = (id, payload) => this.httpClient().post(`${this.baseUri()}/${id}/bulk_save`, payload)
  checkTraffic = id => this.httpClient().get(`${this.baseUri()}/${id}/traffic_check`)
  // params — list filters for "Select all" (same format as GET offer_partner)
  bulkCancelCpaCosts = (data, params) =>
    this.httpClient().post(`${this.baseUri()}/bulk/cancel_cpa_costs`, data, { params, paramsSerializer: paramsSerializerQs })
  bulkUpdateCpaSettings = (data, params) =>
    this.httpClient().post(`${this.baseUri()}/bulk/update_cpa_settings`, data, {
      params,
      paramsSerializer: paramsSerializerQs,
    })
})()
